import { render } from "./TwoFaInfoForm.vue?vue&type=template&id=034adeb8&scoped=true"
import script from "./TwoFaInfoForm.vue?vue&type=script&lang=js"
export * from "./TwoFaInfoForm.vue?vue&type=script&lang=js"

import "./TwoFaInfoForm.vue?vue&type=style&index=0&id=034adeb8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034adeb8"]])

export default __exports__